import {useState} from "react"
import {useTranslation} from "react-i18next"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import useLexicons from "../../swrCustomHooks/useLexicons"
import Select from "react-select"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {toast} from "react-toastify"
import ScrollingMod from "../../tools/ScrollingMod"

export default function SelectLexiconsModalForm({mutateStProject}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {stProjectsContext} = useStProjectsContext()
    const {setLexiconsAction} = useLexiconsContext()
    const {lexicons, mutateLexicons, isLoadingLexicons, isErrorLexicons} = useLexicons()
    const [selectValue, setSelectValue] = useState()
    const options = []

    try {
        for (let lexicon of lexicons) {
            options.push({value: lexicon.id, label: lexicon.name})
        }
    } catch {}

    const closeModal = () => {
        setLexiconsAction({type: "IS_MODAL", payload: {isModal: false}})
        ScrollingMod(false)
    }

    const selectLexiconProject = (event) => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            event.preventDefault()
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            axios.post(`${API_PROJECTS}/${stProjectsContext.projectID}/lexicons/${selectValue.value}`, null, headersRequest)
            .then(() => {
                axios.put(`${API_PROJECTS}/${stProjectsContext.projectID}`, {lexicon_status: "done"}, headersRequest)
                .then(() => {
                    closeModal()
                    mutateLexicons()
                    mutateStProject()
                    })
                    .catch((error) => {
                        console.error("PUT /projects/project: ", error)
                    })
                })
                .catch((error) => {
                    console.error("POST /projects/lexicons: ", error)
                })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (isErrorLexicons || isLoadingLexicons || lexicons.message) return <LoadingComponent/>
    return (
        <>
        <form className="lexicons-modal-form">
            <Select
                isClearable={false}
                isSearchable={false}
                menuShouldScrollIntoView={false}
                maxMenuHeight={110}
                className="basic-single"
                classNamePrefix="select"
                options={options}
                onChange={(value) => setSelectValue(value)}
            />
            <div className="actions">
                <button className="cancel-btn" onClick={closeModal}>{t("Cancel")}</button>
                <button className="append-btn" onClick={selectLexiconProject}>{t("Select")}</button>
            </div>
        </form>
        </>
    )
}